import { Product } from "@/types/product";
import { useTranslation } from "react-i18next";

type DeprecatedLabel = {
  text: string;
  color: string;
};

export const useProductDeprected = () => {
  const { t } = useTranslation();

  const getDeprecatedLabel: (product: Product | null | undefined) => DeprecatedLabel | undefined = (product) => {
    if (product) {
      switch (product?.deprecated) {
        case 1:
          return { text: t('product.deprecated'), color: 'error' };
        case 0:
          return { text: t('product.normalStatus'), color: 'success' };
        default:
          return { text: t('product.notSet'), color: 'blue' };
      }
    }
    return undefined
  }

  return {
    getDeprecatedLabel
  }
}